import $ from 'jquery';
import listService from 'ListService.js';
import { View } from 'backbone';
import _Template from 'properties/table/column-access-hidden.ejs';
import _ from 'lodash';
import util         from 'util/Util.js';

class ColumnAccessHiddenView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _Template;
        this.tagName = 'div';
        this.id = '#accessibilityHidden';
        this.colId = this.model.get('selectedRowId');

        this.events = {
            'change input[type=checkbox]' : 'updateCheckboxAttributes'
        };

        if(this.colId){
            let factorykey=this.model.get('gridData')[this.colId].get('factoryKey');
            util.updateHelpDocumentationLink(factorykey);
        }
      if (!this.model.get('gridData')[this.colId].attributes['deviceTablet']) {
            this.model.get('gridData')[this.colId].attributes.deviceTablet={isHidden:false}
      }

      if (this.model.get('gridData')[this.colId].attributes['devicePhone'] === undefined ) {
        this.model.get('gridData')[this.colId].attributes.devicePhone={isHidden:false}
      }

        this.listenTo(this.model, 'change', this.render);

        return this;
    }


    updateCheckboxAttributes(ev) {
        ev.preventDefault();
        const isHidden  = ev.currentTarget.checked;
        const propName = ev.currentTarget.name;



        if (propName === 'isHiddenTablet') {
            //this.model.get('deviceTablet').isHidden = isHidden;
            this.model.get('gridData')[this.colId].attributes['deviceTablet'].isHidden = isHidden;
        }
        if (propName === 'isHiddenPhone') {
            //this.model.get('devicePhone').isHidden = isHidden;
            this.model.get('gridData')[this.colId].attributes['devicePhone'].isHidden = isHidden;
        }
        this.model.trigger('change');

    }

    render() {
      this.$el.empty();

      if (this.template) {
          this.$el.html(this.template(this.model.toJSON()));
      }

      /*
        PF-2605. Hide this property for now. This should be reactivated later on during the process-
        Please DON'T REMOVE THIS.
      */

      /*const currentFormModel = _.get(listService, 'currentForm.model');
      if(!(currentFormModel && util.isTrue(currentFormModel.get('responsive')))) {
        $('#isHiddenPhone').prop('readonly', 'readonly');
        $('#isHiddenPhone').prop('disabled', 'disabled');
        $('#isHiddenTablet').prop('readonly', 'readonly');
        $('#isHiddenTablet').prop('disabled', 'disabled');
      } else {
        if (this.model.get('gridData')[this.colId].attributes['isMandatory']) {
          // uncheck and disable
          $('#isHiddenPhone').prop('checked', false);
          $('#isHiddenPhone').prop('disabled', 'disabled');
          $('#isHiddenTablet').prop('checked', false);
          $('#isHiddenTablet').prop('disabled', 'disabled');
        } else {
          $('#isHiddenPhone').prop('disabled', '');
          $('#isHiddenTablet').prop('disabled', '');
        }
      }

      this.delegateEvents();*/

      return this;
    }

}

export default ColumnAccessHiddenView;
